import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ logo, duration = 0, onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeInTimeout = setTimeout(() => {
      setFadeOut(true);
    }, duration); // Duration for logo display

    const completeTimeout = setTimeout(() => {
      if (onComplete) onComplete();
    }, duration + 1000); // Add a bit of extra time for fade-out animation

    return () => {
      clearTimeout(fadeInTimeout);
      clearTimeout(completeTimeout);
    };
  }, [duration, onComplete]);

  return (
    <div className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="logo-container">
        {logo && <img src={logo} alt="Logo" className="logo" />}
      </div>
    </div>
  );
};

export default LoadingScreen;